module.exports = __webpack_public_path__ + "img/4.55caa0ac.png";